module.exports = __webpack_public_path__ + "static/media/galway-1.bb77e4a7.jpg";